import React, { useState } from 'react';
import classNames from 'classnames';
import { currency } from 'Helpers/Formats';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import PropTypes from 'prop-types';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import Collapse from '@mui/material/Collapse';
import ExpandLess from '@material-ui/icons/ExpandLess';
import ExpandMore from '@material-ui/icons/ExpandMore';
import { IconButton, ListItemSecondaryAction } from '@material-ui/core';
import Item from './index';
import ReadOnlyItem from './ReadOnly';

const styles = theme => ({
  root: {
    color: theme.palette.facet.primaryGray,
    cursor: 'pointer',
    transitionDuration: '1s',
  },
  divider: {
    borderBottom: '1px solid',
    borderBottomColor: theme.palette.grey[300],
  },
  secondaryDetail: {
    paddingLeft: theme.spacing(2),
    textAlign: 'right',
    flexShrink: 0,
  },
  openBackground: {
    backgroundColor: theme.palette.grey[100],
  },
  rootColorReviewPurple: {
    color: theme.palette.facet.reviewPurple,
  },
  rootColorCompleteGreen: {
    color: theme.palette.facet.completeGreen,
  },
});

const DropdownItem = ({
  className,
  classes,
  name,
  sum,
  items,
  color,
  readOnly,
}) => {
  const [isOpen, setOpenState] = useState(false);

  return (
    <div
      className={classNames(className, classes.root, {
        [classes.openBackground]: isOpen,
      })}
      test={`balance-sheet-items-dropdown-${name}`}
    >
      <ListItem
        className={classNames({
          [classes.divider]: !isOpen,
          [classes.rootColorReviewPurple]: color === 'reviewPurple',
          [classes.rootColorCompleteGreen]: color === 'completeGreen',
        })}
        onClick={() => setOpenState(!isOpen)}
      >
        <ListItemText
          primary={name}
          primaryTypographyProps={{
            variant: 'h5',
            noWrap: true,
          }}
        />
        <ListItemText
          className={classes.secondaryDetail}
          primary={currency(sum, false)}
          primaryTypographyProps={{
            variant: 'h5',
            noWrap: true,
          }}
        />
        <ListItemSecondaryAction>
          <IconButton
            edge="end"
            aria-label={isOpen ? 'close' : 'open'}
            onClick={() => setOpenState(!isOpen)}
          >
            {isOpen ? <ExpandLess /> : <ExpandMore />}
          </IconButton>
        </ListItemSecondaryAction>
      </ListItem>
      <Collapse in={isOpen} timeout="auto" unmountOnExit>
        <List
          component="div"
          className={classes.divider}
        >
          {items.map((item) => {
            return readOnly
              ? (
                <ReadOnlyItem
                  key={`${item.name}-${item.balance}`}
                  color={color}
                  name={item.name}
                  balance={item.balance}
                />)
              : (
                <Item
                  key={`${item.name}-${item.balance}`}
                  color={color}
                  item={item}
                />);
          })}
        </List>
      </Collapse>
    </div>
  );
};

DropdownItem.defaultProps = {
  className: '',
  readOnly: false,
};

DropdownItem.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
  name: PropTypes.string.isRequired,
  sum: PropTypes.number.isRequired,
  items: PropTypes.array.isRequired,
  color: PropTypes.oneOf(['reviewPurple', 'completeGreen']).isRequired,
  readOnly: PropTypes.bool,
};

export default withStyles(styles)(DropdownItem);
